import React from "react";
import DatePickerComponent from "../DatePickerComponent";
import DropDownComponent from "../DropDownComponent";
import DropDownComponentSorted from "../DropDownComponentSorted";
import InputComponent from "../InputComponent";
import InputComponentReadOnly from "../InputComponentReadOnly";
import PhoneNumberInput from "../PhoneNumberInput";
import TextFieldComponent from "../TextFieldComponent";

function PersonalInformation({
  firstName,
  handleFirstNameChange,
  lastName,
  handleLastNameChange,
  nickname,
  handleNicknameChange,
  dob,
  handleDobChange,
  age,
  maritalStatus,
  handleMaritalStatusChange,
  livingWith,
  handleLivingWithChange,
  gender,
  handleGenderChange,
  genderOther,
  handleGenderOther,
  sexualOrientation,
  handleSexualOrientationChange,
  sexualOrientationOther,
  handleSexualOrientationOther,
  clientSource,
  handleClientSourceChange,
  personalEmail,
  handlePersonalEmailChange,
  phoneNumber,
  handlePhoneNumberChange,
  livingWithOther,
  handleLivingWithOther,
  passportNumber,
  handlePassportNumberChange,
  visaExpirationDate,
  handleVisaExpirationDateChange,
  currentAddress,
  handleCurrentAddressChange,
  city,
  handleCityChange,
  province,
  handleProvinceChange,
  country,
  handleCountryChange,
  nationality,
  handleNationalityChange,
  rehabs = [],
  rehabId,
  handleRehabChange,
}) {
  return (
    <div className="general-information-column">
      <div
        className="general-information-card"
      >
        <div className="general-information-heading">
          <span className="general-information-kicker">Client profile</span>
          <h2>Personal Information</h2>
          <p>Identity, contact details and personal profile</p>
        </div>
        <div className="general-information-grid general-information-grid-identity">
          <InputComponent
            title="Firstname"
            width="auto"
            value={firstName}
            onChange={handleFirstNameChange}
          />
          <InputComponent
            title="Lastname"
            width="auto"
            value={lastName}
            onChange={handleLastNameChange}
          />
          <InputComponent
            title="Nickname"
            width="auto"
            value={nickname}
            onChange={handleNicknameChange}
          />
        </div>

        <div className="general-information-grid">
          <DatePickerComponent
            title="Birthday"
            width="150px"
            value={dob}
            onChange={handleDobChange}
          />

          <InputComponentReadOnly
            title="Age (not editable)"
            width="100px"
            value={age}
          />

          <DropDownComponent
            api="maritalStatus"
            title="Marital status"
            value={maritalStatus}
            onChange={handleMaritalStatusChange}
          />
          <DropDownComponentSorted
            api="relationship"
            title="Living with"
            value={livingWith}
            onChange={handleLivingWithChange}
          />
        </div>

        <div className="general-information-grid">
          <DropDownComponent
            api="gender"
            title="Gender"
            value={gender}
            onChange={handleGenderChange}
          />

          {gender === "Other" ? (
            <InputComponent
              title="If other gender, describe"
              width="100px"
              value={genderOther}
              onChange={handleGenderOther}
            />
          ) : (
            ""
          )}

          <DropDownComponent
            api="sexualOrientation"
            title="Sexual orientation"
            value={sexualOrientation}
            onChange={handleSexualOrientationChange}
          />

          {sexualOrientation === "other" ? (
            <InputComponent
              title="If other, describe"
              width="100px"
              value={sexualOrientationOther}
              onChange={handleSexualOrientationOther}
            />
          ) : (
            ""
          )}
          <DropDownComponentSorted
            api="clientSource"
            title="Client source"
            value={clientSource}
            onChange={handleClientSourceChange}
          />
        </div>

        <div className="general-information-grid">
          <InputComponent
            title="Client Email"
            width="auto"
            value={personalEmail}
            onChange={handlePersonalEmailChange}
          />

          <PhoneNumberInput
            title="Client phone number"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
          />

          {livingWith === "Other" ? (
            <InputComponent
              title="If other, describe"
              width="80px"
              value={livingWithOther}
              onChange={handleLivingWithOther}
            />
          ) : (
            ""
          )}
        </div>
        <div className="general-information-grid">
          <InputComponent
            title="Passport number"
            width="150px"
            value={passportNumber}
            onChange={handlePassportNumberChange}
          />
          <DatePickerComponent
            title="Visa expiration date"
            width="150px"
            value={visaExpirationDate}
            onChange={handleVisaExpirationDateChange}
          />
        </div>
        <div className="general-information-grid general-information-grid-address">
          <div className="general-information-address-field">
            <TextFieldComponent
              title="Physical address of residence"
              value={currentAddress}
              onChange={handleCurrentAddressChange}
              width={390}
            />
          </div>
          <InputComponent
            title="City"
            width="auto"
            value={city}
            onChange={handleCityChange}
          />
          <InputComponent
            title="Province / State"
            width="auto"
            value={province}
            onChange={handleProvinceChange}
          />
        </div>
        <div className="tab-form-container">
          <div className="block-input">
            <div className="block-input-line1">
              <div className="input-label-container">
                <div className="input-label">Rehab / Facility</div>
                <select
                  className="add-client-rehab-select"
                  value={rehabId}
                  onChange={handleRehabChange}
                >
                  {rehabs.map((rehab) => (
                    <option key={rehab.id} value={rehab.id}>
                      {rehab.name}
                    </option>
                  ))}
                </select>
              </div>
              <DropDownComponent
                api="countries"
                title="Country"
                value={country}
                onChange={handleCountryChange}
              />
            </div>
            <div className="block-input-line2">
              <DropDownComponent
                api="nationalities"
                title="Nationality"
                value={nationality}
                onChange={handleNationalityChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonalInformation;
